import BaseAPI from './base/base-api';

class GipAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'gip';
}

export default new GipAPI();
